// extracted by mini-css-extract-plugin
module.exports = {"root":"SlideText_root__d1G7d","slider":"SlideText_slider__uIMe9","line":"SlideText_line__78xCW","active":"SlideText_active__BRLwi","inactive":"SlideText_inactive__levQW"};